import { lazy } from 'react';

// ----------------------------------------------------------------------

const FinancePage = lazy(() => import('../pages/Finance.page'));

// ----------------------------------------------------------------------

const FinanceRoutes = [
    {
        path: '/finance',
        element: <FinancePage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { FinanceRoutes };
